import * as React from "react";

const SvgCr = props => <svg width={50} height={33} viewBox="0 0 50 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 1H50V31.7692H0V1Z" fill="white" /><path d="M0 11.2564H50V21.5128H0V11.2564Z" fill="#D22F27" /><path d="M0 26.9109H50V31.7692H0V26.9109ZM0 1H50V5.8583H0V1Z" fill="#1E50A0" /></svg>;

export default SvgCr;